// src/data/proyectosData.js
import p1 from '../assets/proyecto-1.jpg';
import p2 from '../assets/proyecto-2.jpg';
import p3 from '../assets/proyecto-3.jpg';
import p4 from '../assets/proyecto-4.jpg';
import p5 from '../assets/proyecto-5.jpg';
import p6 from '../assets/proyecto-6.jpg';
import p7 from '../assets/proyecto-7.jpg';
import p8 from '../assets/proyecto-8.jpg';

export const proyectos = [
  {
    imagen: p1,
    titulo: 'Montaje de equipo eléctrico para pyme – Santa Ana',
    descripcion:
      'Traslado, izaje y colocación controlada de un equipo eléctrico industrial para una pequeña empresa local.',
    categoria: 'Energía',
    fecha: '23/10/2024',
  },
  {
    imagen: p2,
    titulo: 'Traslado de grupo electrógeno para taller – Marcona',
    descripcion:
      'Carguío, sujeción y descarga con grúa articulada de un generador para un taller metalmecánico.',
    categoria: 'Transporte',
    fecha: '26/07/2024',
  },
  {
    imagen: p3,
    titulo: 'Montaje de estructura metálica para almacén – Lima',
    descripcion:
      'Apoyo de grúa y camión para instalar vigas y marcos en la ampliación de un almacén de una pyme.',
    categoria: 'Construcción',
    fecha: '15/05/2024',
  },
  {
    imagen: p4,
    titulo: 'Transporte urbano de pallets para ferretería',
    descripcion:
      'Recojo, traslado y descarga de carga paletizada y materiales de construcción en zona urbana.',
    categoria: 'Transporte',
    fecha: '10/02/2024',
  },
  {
    imagen: p5,
    titulo: 'Izaje de materiales para obra comercial – Arequipa',
    descripcion:
      'Elevación y posicionamiento de materiales de obra con grúa articulada para un local comercial.',
    categoria: 'Construcción',
    fecha: '05/11/2023',
  },
  {
    imagen: p6,
    titulo: 'Descarga de big-bags de cemento en obra',
    descripcion:
      'Manejo seguro de sacos a granel y agregados con apoyo de camión grúa para proyecto urbano.',
    categoria: 'Construcción',
    fecha: '18/08/2023',
  },
  {
    imagen: p7,
    titulo: 'Levantamiento de columnas para ampliación de local',
    descripcion:
      'Servicio de camión grúa para montaje y vaciado de columnas de concreto en negocio de barrio.',
    categoria: 'Construcción',
    fecha: '12/06/2023',
  },
  {
    imagen: p8,
    titulo: 'Reubicación de tablero eléctrico en planta',
    descripcion:
      'Retiro, traslado y reposicionamiento de equipos eléctricos con camión grúa para mantenimiento.',
    categoria: 'Energía',
    fecha: '28/03/2023',
  },
];
